<template>
    <rkm-table
        paginated
        :busy="busy"
        :fields="fields"
        :items="items"
    >
        <template v-slot:cell(plantonista)="row">
            <span class="d-block">
                <strong>{{ row.item.cidadaoNome }}</strong>
            </span>
            <span class="d-block">
                {{ row.item.ocupacaoCodigoNome }}
            </span>
        </template>
    </rkm-table>
</template>

<script>
// Enums.
import statusPlantao from '@/enums/pronto-atendimento/plantao/status'

// Mixins.
import { error, repository } from '@/mixins'

export default {
    created() {
        this.repositories.plantao = this.getConectaSusRepository('prontoAtendimento.plantao')

        this.load()
    },
    data: () => ({
        busy: false,
        enums: { statusPlantao },
        fields: [
            { key: 'plantonista', label: 'Plantonista' },
            { key: 'inicio', label: 'Data/hora entrada', sortable: true },
            { key: 'fim', label: 'Data/hora saída', sortable: true },
            { key: 'quantidadeAtendimentos', label: 'Atendimento', sortable: true }
        ],
        items: [],
        repositories: {
            plantao: null
        }
    }),
    methods: {
        load() {

            this.busy = true

            this.repositories.plantao.datatable({
                current_date: true,
                one_hour_before_start: true,
                status_id: [
                    this.enums.statusPlantao.CADASTRADO,
                    this.enums.statusPlantao.CONFIRMADO,
                    this.enums.statusPlantao.COM_ATENDIMENTO_AGENDADO,
                ]
            })
                .then(({ data }) => this.items = data)
                .catch(this.handleError)
                .finally(() => this.busy = false)
        }
    },
    mixins: [ error, repository ]
}
</script>